import CountryFlag from 'vue-country-flag'
import {mixin as clickaway} from 'vue-clickaway';

export default {
    mixins: [clickaway],
    props: {
        type: {
            type: String,
            default: ''
        },
        value: {
            type: Array,
            default: []
        },
        label: {
            type: String,
            default: ''
        },
        progress: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        itemValue: {
            type: String,
            default: 'id'
        },
        itemTitle: {
            type: String,
            default: 'name'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            openSelect: false,
            selectedItems: this.value,
        }
    },
    components: {
        CountryFlag
    },
    computed: {
        inputValue() {
            return this.selectedItems.map(e => e[this.itemTitle])
        }
    },
    watch: {
        value() {
            this.selectedItems = this.value;
        }
    },
    created() {
        this.selectedItems = this.value;
    },
    methods: {
        handleCheckbox() {
            this.$emit('input', this.selectedItems);
        },
        awaySelect() {
            this.openSelect = false
        }
    }
}
